/*
 * @Author: sunguangxu
 * @Date: 2025-05-12 20:42:41
 * @LastEditors: sunguangxu
 * @LastEditTime: 2025-05-12 20:45:40
 * @Description:
 */
// 列表状态显示，和 样式说明悬浮框提示内容
import {StatusProps} from "@/types/interfaceTypes";
import {Card, Popover, CardProps, Spin, SpinProps} from "antd";
import React from "react";
import ProDescriptions from "@ant-design/pro-descriptions";
import dayjs from "dayjs";
import '@/global.less'
export const RenderStatus = ({ color = '' , label = '', iconDom }: StatusProps) => {
  return (
    <div style={{
      display:'flex',
      alignItems: 'center',
      width:'fit-content',
      background: color,
      color:'#fff',
      borderRadius: '2px',
      padding:'0 5px'}}
    >
      {iconDom ? <span style={{fontSize: '12px', paddingRight: '5px'}}> {iconDom} </span> : null}{label}
    </div>
  );
};
// 封装的状态显示组件
export const StatusDisplay = ({ color = '' , label = '', moduleName= '加工进度', demoText= '工序'}) => {
  const content = (
    <div>
      <p>说明：<span>该色彩代表{moduleName}为'{label}'</span></p>
      <div style={{display:'flex'}}>示例：
        <RenderStatus color={color} label={demoText} iconDom={null} />
      </div>
    </div>
  );

  return (
    <div style={{display:'inline-block' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span>{label}:&nbsp;</span>
        <Popover content={content} title="">
          <div style={{ display:'inline-block',height:'12px', width: '18px',background: color,  borderRadius: '2px',  marginRight: '5px'}}> </div>
        </Popover>
      </div>
    </div>
  );
};

export const customTableHeaderTitle = (props: {title?: string, partTotalLabel?: string, priceTotalLabel?: string,partTotal?: number, priceTotal?: number}) => {
  const {title, partTotal, priceTotal, partTotalLabel, priceTotalLabel} = props;
  return (<div style={{display: "flex", alignItems: 'flex-end'}}>
    <span style={{display:'inline-block', marginBottom: 'auto'}}>{title || '数据列表：'}</span>
    <div style={{fontSize: '12px', display: "flex",fontWeight: 400,}}>
      {
        (partTotal || partTotal === 0) &&
      <div style={{marginLeft:'8px'}}>
        <span style={{ display: 'inline-block', marginRight: '5px'}}>{partTotalLabel||'当前页面采购总数量'}</span>
        <span style={{display: 'inline-block', marginRight: '15px'}}>(<span style={{fontWeight: 600}}>{partTotal}</span>)</span>
      </div>
      }
      {
        (priceTotal || priceTotal === 0) &&  <div style={{marginLeft:'5px'}}>
          <span style={{ display: 'inline-block', marginRight: '5px'}}>{priceTotalLabel || '当前页面采购总金额' }</span>
          <span style={{display: 'inline-block', marginRight: '5px'}}>(<span style={{fontWeight: 600}}>{priceTotal}</span>)</span>
        </div>
      }
    </div>
  </div>)
}


// 主要是使用ant 统一title样式，body边距样式由传入的children决定，解决嵌套table两层边距问题
export const CustomOnlyTitleCard: React.FC<CardProps> = (props) => {
  return (
    <Card
      styles={{
        header: { borderBottom: 0 },
        body: {
          padding: 0
        },
      }}
      {...props}
    >
    </Card>
  );
}


export const CustomCenterSpin: React.FC<SpinProps>= (props) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      minHeight: 120 /* 默认最小高度，可按需调整 */
    }}>
      <Spin {...props} size={props.size || "large"} />
    </div>
  );
}
export const CustomPartDescriptions = ({bomDescriptionsObj = {}}) => {
  const style = {border:'1px solid #f0f0f0', borderRadius:'8px', padding:'8px 8px 0 8px', marginTop:'10px'}
  return (
    <>
      <ProDescriptions   className="custom-pro-descriptions"
                         title={'零件信息'} style={{...style,marginTop:'0'}} >
        <ProDescriptions.Item label="监控号">{bomDescriptionsObj?.monitorNo}</ProDescriptions.Item>
        <ProDescriptions.Item label="零件编号">{bomDescriptionsObj?.materialNo}</ProDescriptions.Item>
        <ProDescriptions.Item label="零件名称">{bomDescriptionsObj?.materialName}</ProDescriptions.Item>
        <ProDescriptions.Item label="图号">{bomDescriptionsObj?.drawNo || bomDescriptionsObj?.drawingNumber}</ProDescriptions.Item>
        <ProDescriptions.Item label="零件数量">{bomDescriptionsObj?.quantity}</ProDescriptions.Item>
        {bomDescriptionsObj?.sourceType === "SUPPLEMENT" && (
          <ProDescriptions.Item label="原图纸零件数量"> {bomDescriptionsObj?. relationQuantity} </ProDescriptions.Item>
        )}
      </ProDescriptions>

      {/*<ProDescriptions  className="custom-pro-descriptions" title={'物料信息'} style={style}>*/}
      {/*  <ProDescriptions.Item label="物料编号">{bomDescriptionsObj?.rawMaterialNo}</ProDescriptions.Item>*/}
      {/*  <ProDescriptions.Item label="物料名称">{bomDescriptionsObj?.rawMaterialName}</ProDescriptions.Item>*/}
      {/*  <ProDescriptions.Item label="尺寸">{bomDescriptionsObj?.size}</ProDescriptions.Item>*/}
      {/*  <ProDescriptions.Item label="规格">{bomDescriptionsObj?.specs}</ProDescriptions.Item>*/}
      {/*  <ProDescriptions.Item label="材质">{bomDescriptionsObj?.material}</ProDescriptions.Item>*/}
      {/*  <ProDescriptions.Item label="密度">{bomDescriptionsObj?.density}</ProDescriptions.Item>*/}
      {/*</ProDescriptions>*/}

      <ProDescriptions className="custom-pro-descriptions" title={'流转/交付信息'} style={style}>
        <ProDescriptions.Item label="下图日期">{bomDescriptionsObj?.createTime ? dayjs(bomDescriptionsObj.createTime).format("YYYY-MM-DD"):'-'}</ProDescriptions.Item>
        <ProDescriptions.Item label="交付日期">{bomDescriptionsObj?.bomLeadDate? dayjs(bomDescriptionsObj.bomLeadDate).format("YYYY-MM-DD") : '-'}</ProDescriptions.Item>
      </ProDescriptions>

      <ProDescriptions className="custom-pro-descriptions" title={'工艺信息'} style={style}>
        <ProDescriptions.Item label="工艺类别">{bomDescriptionsObj?.category}</ProDescriptions.Item>
      </ProDescriptions>

      <ProDescriptions className="custom-pro-descriptions" title={'项目信息'} style={style}>
        <ProDescriptions.Item label="项目名称">{bomDescriptionsObj?.projectName}</ProDescriptions.Item>
        <ProDescriptions.Item label="项目编号">{bomDescriptionsObj?.projectNo}</ProDescriptions.Item>
      </ProDescriptions>

      <ProDescriptions className="custom-pro-descriptions" title={'客户信息'} style={style}>
        <ProDescriptions.Item label="客户名称">{bomDescriptionsObj?.customerName}</ProDescriptions.Item>
      </ProDescriptions>

      <ProDescriptions className="custom-pro-descriptions" title={'供应商信息'} style={style}>
        <ProDescriptions.Item label="预发厂商名称">{bomDescriptionsObj?.preSupplierName}</ProDescriptions.Item>
        <ProDescriptions.Item label="供应商名称">{bomDescriptionsObj?.supplierName}</ProDescriptions.Item>
      </ProDescriptions>
    </>
  );
}
